import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import DataTable, { Column } from '@repo/ui/data-table'
import { ExclamationMarkIcon } from '@repo/ui/icons'
import { useQuery } from '@tanstack/react-query'

import { getCenterTefls } from '../../../../../api/centers/center-tefl/get-center-tefls'
import useTranslate from '../../../../../lib/hooks/use-translate'
import { TeflTypeEnum } from '../../../../../lib/types/enums/ol/tefl-type.enum'
import { CenterTefl } from '../../../../../lib/types/models/center-tefl/center-tefl'

type Props = {
  centerId: number
  olId?: number
  columns: Column<CenterTefl>[]
}

const OlCenterTeflList = ({ centerId, columns }: Props) => {
  const { t } = useTranslate()

  const { data: centerTefls } = useQuery({
    queryKey: ['center-tefls', centerId],
    queryFn: () => getCenterTefls(centerId)
  })

  const qualificationLength = Object.values(TeflTypeEnum).length
  //get the tefls that are undefined or null in centerTefls.data
  const unassignedTefls = centerTefls?.data.filter((centerTefl) => !!centerTefl.tefl).length ?? 0

  const remainingTefls = (centerTefls?.data.length ?? qualificationLength) - unassignedTefls

  return (
    <div>
      {remainingTefls > 0 && (
        <Badge
          color={tailwindColors.red.secondary.light.DEFAULT}
          text={`${remainingTefls} ${t('ol-center.tefl.table.badge.text')}`}
          textColor={tailwindColors.red.secondary.DEFAULT}
          iconPosition="start"
          icon={
            <div className="rounded-full border border-red-secondary p-0.5">
              <ExclamationMarkIcon color={tailwindColors.red.secondary.DEFAULT} />
            </div>
          }
        />
      )}
      <div className="h-3" />
      <DataTable<CenterTefl>
        bodyVariant="white"
        paginated={false}
        rowCount={centerTefls?.data.length ?? 0}
        data={centerTefls?.data ?? []}
        columns={columns}
      />
    </div>
  )
}

export default OlCenterTeflList
